import _ from 'lodash';
import { store } from '../redux/store';
import { ROLE_BASED_PERMISSIONS } from './permissions';

export const getPermissionsStore = path => {
  return _.get(store.getState()?.current?.permissions, path, false);
};

export const checkPermissions = obj =>
  obj && typeof obj === 'object'
    ? Object.values(obj).map(checkPermissions).flat()
    : [obj];

export const getModuleAllowed = moduleName => {
  return checkPermissions(
    store.getState()?.current?.permissions[moduleName]
  ).some(a => a === true);
};

let DEFAULT_VALUES = {};
export const generateDefaultValues = (
  rolePermissions,
  licensePermissions,
  roles,
  licenses
) => {
  Object.keys(rolePermissions).forEach(key => {
    if (
      typeof rolePermissions[key] === 'object' &&
      !rolePermissions[key].hasOwnProperty('administrator')
    ) {
      generateDefaultValues(
        rolePermissions[key],
        licensePermissions[key],
        roles,
        licenses
      );
    } else {
      let obj = rolePermissions[key];
      Object.keys(rolePermissions[key]).forEach(roleData => {
        obj[roleData] =
          licenses.some(l => licensePermissions[key][l] === true) &&
          rolePermissions[key][roleData];
      });
      _.set(
        DEFAULT_VALUES,
        [...getParentKeys(ROLE_BASED_PERMISSIONS, key), key].join('.'),
        obj
      );
    }
  });
  return DEFAULT_VALUES;
};

export const getParentKeys = (object, keyName, currentPath = []) => {
  if (typeof object !== 'object' || object === null) {
    return null;
  }
  if (keyName in object) {
    return [...currentPath];
  }
  for (const key in object) {
    const parentKeys = getParentKeys(object[key], keyName, [
      ...currentPath,
      key,
    ]);
    if (parentKeys !== null) {
      return parentKeys;
    }
  }
  return null;
};

export const insertSpaces = string => {
  string = string.replace(/([a-z])([A-Z])/g, '$1 $2');
  string = string.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
  return string
    .split(' ')
    .map(m => _.capitalize(m))
    .join(' ');
};
